.container {
  height: 48px;
  padding-top: 8px;
}

.slider {
  position: relative;
  width: 280px;
}

.sliderTrack,
.sliderRange,
.sliderLeftValue,
.sliderRightValue {
  position: absolute;
}

.sliderTrack,
.sliderRange {
  border-radius: 3px;
  height: 5px;
}

.sliderTrack {
  background-color: #ced4da;
  width: 100%;
  z-index: 1;
}

.sliderRange {
  background-color: #6366f1;
  z-index: 2;
}

.sliderLeftValue,
.sliderRightValue {
  color: #334155;
  font-size: 12px;
  margin-top: 20px;
}

.sliderLeftValue {
  left: 6px;
}

.sliderRightValue {
  right: -4px;
}

/* Removing the default appearance */
.thumb,
.thumb::-webkit-slider-thumb {
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
}

.thumb {
  pointer-events: none;
  position: absolute;
  height: 0;
  width: 280px;
  outline: none;
}

.thumbZindex3 {
  z-index: 3;
}

.thumbZindex4 {
  z-index: 4;
}

.thumbZindex5 {
  z-index: 5;
}

/* For Chrome browsers */
.thumb::-webkit-slider-thumb {
  background-color: #f1f5f7;
  border: none;
  border-radius: 50%;
  box-shadow: 0 0 1px 1px #ced4da;
  cursor: pointer;
  height: 18px;
  width: 18px;
  margin-top: 4px;
  pointer-events: all;
  position: relative;
}

/* For Firefox browsers */
.thumb::-moz-range-thumb {
  background-color: #f1f5f7;
  border: none;
  border-radius: 50%;
  box-shadow: 0 0 1px 1px #ced4da;
  cursor: pointer;
  height: 18px;
  width: 18px;
  margin-top: 4px;
  pointer-events: all;
  position: relative;
}

.marius {
  color: #ff0000;
}
